import { useSelector, shallowEqual } from 'react-redux';

import type AppState from 'src/types/appState';

import { getCreateFlowOrderJobId } from './getCreateFlowOrderJobId';

export const usePostedJobIdSelector = (): string | undefined => {
  const { cart, flowType, jobId, sourceJobId } = useSelector(
    (state: AppState) => ({
      cart: state.session.cart,
      flowType: state.formData.flowType,
      jobId: state.session.job?.id,
      sourceJobId: state.session.sourceJobId,
    }),
    shallowEqual,
  );

  if (flowType === 'edit') {
    return sourceJobId;
  }

  // Using orderJobId instead of session.job.id
  // should resolve most of the Notification Preference DLQ issue
  if (flowType === 'create') {
    return getCreateFlowOrderJobId(cart);
  }

  return jobId;
};
